// extracted by mini-css-extract-plugin
export default {"adTab":"AdTab_adTab__1sxT-"};